import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Exige pelo menos nome e sobrenome (duas palavras ou mais). */
export function fullNameRequiresLastNameValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (value == null || String(value).trim() === '') {
    return null;
  }

  const parts = String(value).trim().split(/\s+/).filter(Boolean);

  if (parts.length < 2) {
    return { fullNameMissingLastName: true };
  }

  return null;
}
